import type { OnyxComponentInputs, OnyxTableColumn } from '@onyx/angular';
import { AddressCellComponent } from '../../../../../common/components/cells/address-cell/address-cell.component';
import { StringCellComponent } from '../../../../../common/components/cells/string-cell/string-cell.component';
import { PointsOfInterestGateCellComponent } from '../../../points-of-interest/common/cells/points-of-interest-gate-cell/points-of-interest-gate-cell.component';
import type { ContractorPointsOfInterestFormGroup } from '../../contractor-form/contractor-points-of-interest-form/contractor-points-of-interest-form.component';

export const CONTRACTORS_POINTS_OF_INTEREST_COLUMNS: OnyxTableColumn<ContractorPointsOfInterestFormGroup>[] =
  [
    {
      id: 'name',
      name: 'labels.name',
      width: 'fill',
      component: {
        ref: StringCellComponent,
        inputs: (data): OnyxComponentInputs<StringCellComponent> => ({
          value: data.item.controls.pointOfInterest.getRawValue().name,
        }),
      },
    },
    {
      id: 'location',
      name: 'labels.location',
      width: '110px',
      component: {
        ref: AddressCellComponent,
        inputs: (data): OnyxComponentInputs<AddressCellComponent> => ({
          address: data.item.controls.pointOfInterest.getRawValue().address,
          format: 'full',
          showFlag: false,
        }),
      },
    },
    {
      id: 'gate',
      name: 'labels.gate',
      width: '100px',
      component: {
        ref: PointsOfInterestGateCellComponent,
        inputs: (
          data,
        ): OnyxComponentInputs<PointsOfInterestGateCellComponent> => ({
          gate: data.item.controls.gate,
        }),
      },
    },
  ];
